import './ResetPassword.scss'
import './Login.scss'

import React, {Component} from 'react'
import { Button, Input } from 'react-bootstrap'
import Alert from 'common/views/atoms/Alert/Alert'
import RdcBrandedLogo from '../../../../../common/src/views/atoms/RdcBrandedLogo'
import ResetPasswordSuccessImage from '../../../../../common/src/views/atoms/ResetPasswordSuccessImage'

import { resetPassword } from 'common/redux/auth'

class ResetPassword extends Component {

    constructor(props) {
      super(props)
      this.state = {
        username: '',
        usernameError: ''
      }
      this.handleSubmit = this.handleSubmit.bind(this)
    }

    validate = () => {
      let usernameError=''
      if (!this.state.username.includes('@')) {
        usernameError = 'Not a valid email address'
      }
      if (usernameError) {
        this.setState({ usernameError })
        return false
      }
      return true
    }

    handleSubmit(e) {
        e.preventDefault()
        const isValid = this.validate()
        if (isValid) {
        this.props.dispatch(resetPassword(this.state.username))
        }
    } 

    render() {
      
      const {finished_reset, reset_email} = this.props.auth

      const isEnabled = this.state.username.length > 2
      const borderColorIfValidationFails = this.state.usernameError ? "ResetPassword__input invalid" : "ResetPassword__input"
      const labelColorIfValidationFails = this.state.usernameError ? "ResetPassword__label invalid" : "ResetPassword__label"
      
      const form = 
      <div className='login-inner'>
        <div> 
          <a className="ResetPassword__arrow__left" href="/login"> &lt;--- Login</a>
        </div>
        <RdcBrandedLogo />
        <div className="ResetPassword__subtitle">Forgot password?
        </div>
        <div className="ResetPassword__subtitle__p">Enter your email address and we'll send you a link to reset your password.
        </div>
        <div>
          <label className={labelColorIfValidationFails}>Email
            <input 
              type="text" 
              className={borderColorIfValidationFails} 
              value={this.state.username} 
              onChange={(e) => this.setState({username:e.target.value})} 
            />
          </label>
        </div>
        {this.state.usernameError ? 
          <div style ={{ fontsize: 10, marginTop: -20,  color: '#D92228' }}>
            {this.state.usernameError}
          </div> : null 
        }  
        <div>
          {!isEnabled ?
            <Button bsClass="ResetPassword__button" type="submit">Send</Button> :
            <Button bsClass="ResetPassword__button_active"  type="submit"> Send </Button> 
          }
        </div>
        </div>

          const success = 
          <div className='login-inner'>
            <RdcBrandedLogo />
              <div className="ResetPassword__subtitle">Success!</div>
              <div className="ResetPassword__subtitle__p">Check your email for instructions on how to reset your password and log back in.
              </div>
            <ResetPasswordSuccessImage />
          </div>

      return (
        <div className='ResetPassword'>
          <form onSubmit={this.handleSubmit}>
            <div>{ finished_reset }</div>
            { !finished_reset ? form : success}
          </form>
        </div>
      )
    }
}

export default ResetPassword
